module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vlymp7-9491b4ed21e9c6b58b2ae4620439796c.jpg";